<!-- Zweck: Stellt die HTML-Struktur für dashboard widgets imp warenkorb ticker component im Frontend bereit. -->
<dashboard-widget>
  <div icon>
    <svg-icon>auftragsplaner</svg-icon>
  </div>
  <div header1 matTooltip="Import Abschluss">
    Import Abschluss
  </div>
  <div content>
    @if (next_cron_import_diff|async) {
      <div style="text-align: center">
        @if ((cron_import_enabled|async)) {
          <div style="padding: 5px">
            <b>Nächster automatischer Importabschluss:</b>
          </div>
        }
        @if (!(cron_import_enabled|async)) {
          <div style="padding: 5px">
            <b>Nächster Importabschluss:</b>
          </div>
        }
        <div style="padding: 5px">
          <span style="font-size: 24px;">{{next_cron_import_run|async}}</span>
        </div>
        <div style="padding: 5px">
          <span style="font-size: 24px;">{{next_cron_import_diff|async}}</span>
        </div>
        @if (!(cron_import_enabled|async)) {
          <div style="color: red">
            Automatischer Abschluss deaktiviert!
          </div>
        }
      </div>
    }
  </div>
</dashboard-widget>
